/* eslint-disable eqeqeq */
import { TableContainer, Table, TableBody, TableHead, TableRow, TableCell } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { sumOfField } from "../../../services/libService";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

// BK.1 BK.2 v..v...
export default function CIListInvs({ tableData = undefined, ciData }) {
  const [data, setData] = useState(tableData);
  const { t } = useTranslation();
  /** Change logic to isPN */
  const isPN = Boolean(data.type === 1);
  const isShowUnitAndQuantity = isPN || (!isPN && data.loadingtype_id == 5);
  useEffect(() => {
    if (!tableData) return;
    setData(tableData);
    // if (!data) getSingleCI(id).then(res => setData(res.data)).catch(err => console.log(err))
  }, [tableData]);
  const renderTable = () => {
    if (tableData)
      return (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {!isPN ? "No." : "STT"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {!isPN ? "Date" : "Ngày"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray", display: ciData.airline === "Adhoc" ? "" : "none" }} align="center" rowSpan={2}>
                  Airline
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {!isPN ? "Tax Invoice No." : "Số HĐ"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {!isPN ? "Receipt No." : "Số phiếu GN"}
                </TableCell>
                {data.loadingtype_id == 1 && (
                  <>
                    <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                      {!isPN ? "Code of Aircraft" : "Đăng bạ tàu bay"}
                    </TableCell>
                    <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                      {!isPN ? "Route" : "Tuyến bay"}
                    </TableCell>
                    <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                      {!isPN ? "Flight No." : "Số chuyến bay"}
                    </TableCell>
                    <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                      {!isPN ? "Obsd. Density" : "Tỷ trọng thực tế"}
                    </TableCell>
                    <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                      {!isPN ? "Temp" : "Nhiệt độ"} (°C)
                    </TableCell>
                  </>
                )}
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={1} colSpan={3}>
                  {!isPN ? "Quantity" : "Số lượng"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {!isPN ? `Unit price (USD/${ciData?.unit || ""})` : `Đơn giá (VNĐ/${ciData?.unit || ""})`}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {!isPN ? "Amount (USD)" : "Thành tiền (VNĐ)"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  VAT {!isPN ? "(USD)" : "(VNĐ)"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {!isPN ? "Total Amount (USD)" : "Tổng tiền (VNĐ)"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} padding="checkbox" align="center">
                  {!isShowUnitAndQuantity ? "Gallon" : ciData.unit}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} padding="checkbox" align="center">
                  {!isPN ? "Litre" : "Lít TT"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} padding="checkbox" align="center">
                  KG
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.invoices?.map((item, index) => (
                <TableRow key={index + 1}>
                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                    {index + 1}
                  </TableCell>
                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                    {item.valid_date && moment(item.valid_date).format("DD/MM/YYYY")}
                  </TableCell>
                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray", display: ciData.airline === "Adhoc" ? "" : "none" }}>
                    {item.adhoc_shippedto}
                  </TableCell>
                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                    {item.code}
                  </TableCell>
                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                    <Link target="_blank" to={`/invoices/${item.id}`}>
                      <Box sx={{ color: "initial", "&:hover": { cursor: "pointer", color: "blue", textDecoration: "underline" } }}>{item.fkey}</Box>
                    </Link>
                  </TableCell>
                  {data.loadingtype_id == 1 && (
                    <>
                      <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                        {item.code_aircraft}
                      </TableCell>
                      <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                        {item.route}
                      </TableCell>
                      <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                        {item.flight_no}
                      </TableCell>
                      <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                        {item.density == "" ? "-" : (+item.density)?.toLocaleString(!isPN ? "ja-JP" : "de-DE", { minimumFractionDigits: 4, maximumFractionDigits: 4 })}
                      </TableCell>
                      <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                        {item.temp == "" ? "-" : (+item.temp)?.toLocaleString(!isPN ? "ja-JP" : "de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                    </>
                  )}
                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {Math.round(!isShowUnitAndQuantity ? item.sub_gallon : item.sub_quantity)?.toLocaleString(!isPN ? "ja-JP" : "de-DE")}
                  </TableCell>
                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {!isPN ? Math.round(item.sub_lit)?.toLocaleString() : Intl.NumberFormat("de-DE").format(item.sub_lit)}
                  </TableCell>
                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {!isPN ? Math.round(item.sub_kg)?.toLocaleString() : Intl.NumberFormat("de-DE").format(item.sub_kg)}
                  </TableCell>
                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {item.price ? (!isPN ? Intl.NumberFormat("ja-JP", { minimumFractionDigits: 4, maximumFractionDigits: 4 }).format(item.price) : Intl.NumberFormat("de-DE").format(item.price)) : "-"}
                  </TableCell>
                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {!isPN ? Intl.NumberFormat("ja-JP", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.sub_amount) : Intl.NumberFormat("de-DE").format(item.sub_amount)}
                  </TableCell>
                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {item.vat === -1 ? "\\" : !isPN ? Intl.NumberFormat("ja-JP", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.vat) : Intl.NumberFormat("de-DE").format(item.vat)}
                  </TableCell>
                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {!isPN ? Intl.NumberFormat("ja-JP", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.total) : Intl.NumberFormat("de-DE").format(item.total)}
                  </TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}></TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }} colSpan={(data.loadingtype_id == 1 ? 8 : 3) + (ciData.airline == "Adhoc" ? 1 : 0)}>
                  {!isPN ? "TOTAL" : "TỔNG CỘNG"}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                  {Math.round(sumOfField(data.invoices, !isShowUnitAndQuantity ? "sub_gallon" : "sub_quantity"))?.toLocaleString(!isPN ? "ja-JP" : "de-DE")}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                  {!isPN ? Math.round(sumOfField(data.invoices, "sub_lit"))?.toLocaleString() : Intl.NumberFormat("de-DE").format(sumOfField(data.invoices, "sub_lit"))}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                  {!isPN ? Math.round(sumOfField(data.invoices, "sub_kg"))?.toLocaleString() : Intl.NumberFormat("de-DE").format(sumOfField(data.invoices, "sub_kg"))}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}></TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                  {!isPN
                    ? Intl.NumberFormat("ja-JP", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(sumOfField(data.invoices, "sub_amount"))
                    : Intl.NumberFormat("de-DE").format(sumOfField(data.invoices, "sub_amount"))}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                  {!isPN
                    ? Intl.NumberFormat("ja-JP", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
                        sumOfField(
                          data.invoices?.filter((item) => item.vat > 0),
                          "vat"
                        )
                      )
                    : Intl.NumberFormat("de-DE").format(
                        sumOfField(
                          data.invoices?.filter((item) => item.vat > 0),
                          "vat"
                        )
                      )}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                  {!isPN
                    ? Intl.NumberFormat("ja-JP", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(sumOfField(data.invoices, "total"))
                    : Intl.NumberFormat("de-DE").format(sumOfField(data.invoices, "total"))}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      );
  };
  if (data)
    return (
      <div style={{ padding: "30px 70px", margin: "auto" }}>
        <div style={{ display: "flex" }}>
          <div align="center" style={{ width: "30%", fontWeight: "bolder", fontSize: 16 }}>
            {!isPN ? (
              "Petrolimex Aviation JSC"
            ) : (
              <div>
                CTCP NHIÊN LIỆU BAY PETROLIMEX
                <br />
                Văn phòng chính
              </div>
            )}
          </div>
          <div style={{ textAlign: "left", marginLeft: "30px" }}>
            <div style={{ color: "#172972", fontSize: "25px", fontWeight: "bolder", margin: "30px 0", textTransform: "uppercase" }}>
              {isPN ? "BẢNG KÊ CHI TIẾT XUẤT BÁN" : "Statement for fuel uplift"}
            </div>
            {!isPN ? "From date" : "Từ ngày"} {data.period_start_time && moment(data.period_start_time).format("DD/MM/YYYY")} {!isPN ? "to date" : "đến ngày"}{" "}
            {data.period_end_time && moment(data.period_end_time).format("DD/MM/YYYY")}
            <br />
            {!isPN ? "Location" : "Kho hàng"}: {ciData.location}
            <br />
            {!isPN ? "Loading type" : "Phương thức tra nạp"}: {ciData.de_type}
            <br />
            {!isPN ? "Route" : "Tuyến"}: {t(ciData?.saletype, { lng: !isPN ? "en" : "vi" })}
            <br />
            {!isPN ? "Customer" : "Khách hàng"}: {`${data.customer?.name + (ciData.airline ? ` / ${ciData.airline}` : "")}`}
            <br />
          </div>
        </div>
        {renderTable()}
        <div style={{ display: "flex", marginTop: "20px" }}>
          <div style={{ width: "55%", textAlign: "left" }}>
            {!isPN ? "Print time" : "Ngày giờ in"}: {moment(Date.now()).format("DD/MM/YYYY HH:mm")}
          </div>
          <div style={{ textAlign: "left", paddingTop: 20, fontWeight: "bolder", fontSize: 17 }}>{!isPN ? "PETROLIMEX AVIATION FUEL JOINT STOCK COMPANY" : "CTY CP NHIÊN LIỆU BAY PETROLIMEX"}</div>
        </div>
      </div>
    );
  else return "";
}
